{
  "/images/blog/6-MILLION-VIEWS-300x300.png": {
    "w": 300,
    "h": 300,
    "v": [
      300
    ]
  },
  "/images/blog/back-to-school-1024x682.jpg": {
    "w": 1024,
    "h": 682,
    "v": [
      480,
      800,
      1024
    ]
  },
  "/images/blog/bafd_2017-225x300.jpg": {
    "w": 225,
    "h": 300,
    "v": []
  },
  "/images/blog/Chiro-land.jpg": {
    "w": 600,
    "h": 900,
    "v": [
      480,
      600
    ]
  },
  "/images/blog/chiropractor-royal-oak-easter-bunny-visit-2017.jpg": {
    "w": 429,
    "h": 600,
    "v": [
      429
    ]
  },
  "/images/blog/Church-of-Beechtown.jpg": {
    "w": 480,
    "h": 672,
    "v": [
      480
    ]
  },
  "/images/blog/copcar.jpg": {
    "w": 400,
    "h": 300,
    "v": []
  },
  "/images/blog/easter-bunny-march-23.jpg": {
    "w": 400,
    "h": 514,
    "v": [
      400
    ]
  },
  "/images/blog/Easter-Bunny-march2020.jpg": {
    "w": 350,
    "h": 350,
    "v": [
      350
    ]
  },
  "/images/blog/flyer-2017-small.jpeg": {
    "w": 275,
    "h": 388,
    "v": [
      275
    ]
  },
  "/images/blog/gallery-1.jpg": {
    "w": 400,
    "h": 300,
    "v": []
  },
  "/images/blog/gallery-10.jpg": {
    "w": 400,
    "h": 300,
    "v": []
  },
  "/images/blog/gallery-11.jpg": {
    "w": 400,
    "h": 300,
    "v": []
  },
  "/images/blog/gallery-2.jpg": {
    "w": 400,
    "h": 300,
    "v": []
  },
  "/images/blog/gallery-8-300x225.jpg": {
    "w": 300,
    "h": 225,
    "v": []
  },
  "/images/blog/gallery-9.jpg": {
    "w": 400,
    "h": 300,
    "v": []
  },
  "/images/blog/johnsons-family.jpg": {
    "w": 425,
    "h": 425,
    "v": []
  },
  "/images/blog/kids-day-flyer-2018.jpg": {
    "w": 213,
    "h": 290,
    "v": [
      213
    ]
  },
  "/images/blog/kids-day-flyer-2019.jpg": {
    "w": 309,
    "h": 290,
    "v": [
      309
    ]
  },
  "/images/blog/kids-day-flyer-pink.jpg": {
    "w": 1778,
    "h": 2512,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/blog/kids-day-log.jpg": {
    "w": 400,
    "h": 284,
    "v": [
      400
    ]
  },
  "/images/blog/Laser-Therapy.jpg": {
    "w": 425,
    "h": 425,
    "v": [
      425
    ]
  },
  "/images/blog/leagueGroupPhoto.jpg": {
    "w": 400,
    "h": 300,
    "v": [
      400
    ]
  },
  "/images/blog/little-girl-and-clown.jpg": {
    "w": 400,
    "h": 300,
    "v": [
      400
    ]
  },
  "/images/blog/Perfect-Storm-1-300x166.png": {
    "w": 300,
    "h": 166,
    "v": [
      300
    ]
  },
  "/images/blog/reptile_man_snakes-300x200.jpg": {
    "w": 300,
    "h": 200,
    "v": []
  },
  "/images/blog/sam.jpeg": {
    "w": 198,
    "h": 300,
    "v": []
  },
  "/images/blog/Santa-Poster-event-2018.jpg": {
    "w": 350,
    "h": 420,
    "v": [
      350
    ]
  },
  "/images/blog/social/baby-chiropractor-royal-oak-first-visit.webp": {
    "w": 1080,
    "h": 1920,
    "v": [
      480,
      800,
      1080
    ]
  },
  "/images/blog/social/chiropractor-ear-pain-royal-oak-bernie.webp": {
    "w": 1080,
    "h": 1920,
    "v": [
      480,
      800,
      1080
    ]
  },
  "/images/blog/social/fall-sports-kids-sports-chiropractor-royal-oak.webp": {
    "w": 1080,
    "h": 1350,
    "v": [
      480,
      800,
      1080
    ]
  },
  "/images/blog/social/family-chiropractor-royal-oak-text-topic-handout-v2.webp": {
    "w": 1080,
    "h": 1350,
    "v": [
      480,
      800,
      1080
    ]
  },
  "/images/blog/social/gentle-chiropractic-care-for-pots-royal-oak.webp": {
    "w": 1080,
    "h": 1920,
    "v": [
      480,
      800,
      1080
    ]
  },
  "/images/blog/social/leaf-raking-tips-royal-oak-family-chiropractor.webp": {
    "w": 1080,
    "h": 1350,
    "v": [
      480,
      800,
      1080
    ]
  },
  "/images/blog/social/meet-tricia-royal-oak-family-chiropractor.webp": {
    "w": 1080,
    "h": 1350,
    "v": [
      480,
      800,
      1080
    ]
  },
  "/images/blog/social/pots-chiropractor-royal-oak-audreys-story.webp": {
    "w": 720,
    "h": 1280,
    "v": []
  },
  "/images/blog/social/pots-chiropractor-royal-oak-dr-zach-conner.webp": {
    "w": 1080,
    "h": 1920,
    "v": [
      480,
      800,
      1080
    ]
  },
  "/images/blog/social/pots-chiropractor-royal-oak-heart-races-standing.webp": {
    "w": 1080,
    "h": 1920,
    "v": [
      480,
      800,
      1080
    ]
  },
  "/images/blog/social/pots-chiropractor-royal-oak-layers-of-stress.webp": {
    "w": 1080,
    "h": 1920,
    "v": [
      480,
      800,
      1080
    ]
  },
  "/images/blog/social/pots-chiropractor-royal-oak-nervous-system-scans.webp": {
    "w": 1080,
    "h": 1920,
    "v": [
      480,
      800,
      1080
    ]
  },
  "/images/blog/social/pots-chiropractor-royal-oak-old-stress.webp": {
    "w": 1080,
    "h": 1920,
    "v": [
      480,
      800,
      1080
    ]
  },
  "/images/blog/social/pots-chiropractor-royal-oak-standing-heart-racing.webp": {
    "w": 1080,
    "h": 1920,
    "v": [
      480,
      800,
      1080
    ]
  },
  "/images/blog/social/pots-chiropractor-royal-oak-whole-body.webp": {
    "w": 1080,
    "h": 1920,
    "v": [
      480,
      800,
      1080
    ]
  },
  "/images/blog/social/rochester-rd-northbound-only-royal-oak-chiropractor.webp": {
    "w": 1080,
    "h": 1350,
    "v": [
      480,
      800,
      1080
    ]
  },
  "/images/blog/social/vital-vitamins-chiropractor-vitamins-royal-oak.webp": {
    "w": 1080,
    "h": 1920,
    "v": [
      480,
      800,
      1080
    ]
  },
  "/images/blog/social/why-chiropractic-care-takes-time-royal-oak.webp": {
    "w": 1080,
    "h": 1920,
    "v": [
      480,
      800,
      1080
    ]
  },
  "/images/blog/social/why-heart-races-when-you-stand-pots.webp": {
    "w": 1080,
    "h": 1920,
    "v": [
      480,
      800,
      1080
    ]
  },
  "/images/blog/Special-Offer-coupon-1024x687.jpg": {
    "w": 1024,
    "h": 687,
    "v": [
      480,
      800,
      1024
    ]
  },
  "/images/blog/tn_heather-s.jpg": {
    "w": 150,
    "h": 150,
    "v": []
  },
  "/images/blog/tn_joey-s.jpg": {
    "w": 150,
    "h": 150,
    "v": []
  },
  "/images/blog/tn_sam-r.jpg": {
    "w": 150,
    "h": 150,
    "v": []
  },
  "/images/blog/tn-gift-of-health.jpg": {
    "w": 300,
    "h": 300,
    "v": []
  },
  "/images/blog/top-25-youtube-award.png": {
    "w": 275,
    "h": 275,
    "v": [
      275
    ]
  },
  "/images/blog/Vanessa-neale.jpg": {
    "w": 198,
    "h": 300,
    "v": []
  },
  "/images/check-in.jpg": {
    "w": 425,
    "h": 425,
    "v": []
  },
  "/images/conditions/johr-temple.jpg": {
    "w": 425,
    "h": 425,
    "v": [
      425
    ]
  },
  "/images/conditions/saylor-kid-adjust.jpg": {
    "w": 425,
    "h": 425,
    "v": [
      425
    ]
  },
  "/images/insight-scan-wide.jpg": {
    "w": 1200,
    "h": 550,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/johr-neck-adjust.jpg": {
    "w": 425,
    "h": 425,
    "v": []
  },
  "/images/library/px-1-question-regarding-our-childrens-health.jpg": {
    "w": 1200,
    "h": 800,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-3-developmental-milestones-that-pave-the-way-for-speech-sensory-and-social-development.jpg": {
    "w": 1200,
    "h": 733,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-3-stages-of-subluxation.jpg": {
    "w": 1200,
    "h": 752,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-4-phases-of-real-healing.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-a-comprehensive-approach-to-alleviating-fight-or-flight-stress-in-children.jpg": {
    "w": 1200,
    "h": 992,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-a-deep-dive-into-nervous-system-regulation.jpg": {
    "w": 1200,
    "h": 874,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-abdominal-migraines-in-children.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-add-vs-adhd.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-adhd-and-bedwetting.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-adhd-and-gut-health.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-adhd-and-sleep-problems.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-adhd-in-teens.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-adhd-mood-swings.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-adhd-test.jpg": {
    "w": 1200,
    "h": 776,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-adult-autism-assessment.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-advocate-for-your-child.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-allergies-vs-cold.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-an-exhausted-moms-survival-guide-navigating-motherhood-with-adaptability-and-resilience.jpg": {
    "w": 1200,
    "h": 1061,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-anxiety-sympathetic-nervous-system.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-anxiety-test.jpg": {
    "w": 1200,
    "h": 1419,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-apraxia-of-speech.jpg": {
    "w": 1200,
    "h": 1002,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-are-there-different-types-of-autism.jpg": {
    "w": 1200,
    "h": 1053,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-asperger-syndrome-in-children.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-aspergers-syndrome.jpg": {
    "w": 1200,
    "h": 883,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-ataxia-in-children.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-atonic-seizure.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-attention-adhd-families-has-your-doctor-ever-told-you-about-a-medication-break.jpg": {
    "w": 1200,
    "h": 652,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-auditory-processing-disorder.jpg": {
    "w": 1200,
    "h": 1132,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-autism-and-sensory-issues.jpg": {
    "w": 1200,
    "h": 799,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-autism-education.jpg": {
    "w": 1200,
    "h": 675,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-autism-medication.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-autism-obsessions.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-autism-spectrum-challenges-and-chiropractic-care.jpg": {
    "w": 1200,
    "h": 969,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-autism-stimming.jpg": {
    "w": 1200,
    "h": 800,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-autism-vs-sensory-processing-disorder.jpg": {
    "w": 1200,
    "h": 845,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-autistic-burnout.jpg": {
    "w": 1200,
    "h": 772,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-autoimmune-disease-in-children.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-autonomic-nervous-system.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-baby-arching-back.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-baby-crying-in-sleep.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-baby-milestones.jpg": {
    "w": 1200,
    "h": 722,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-baby-not-crawling.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-behavioral-issues-in-toddlers.jpg": {
    "w": 1200,
    "h": 912,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-behavioral-therapy.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-birth-injury.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-birth-preparation-tip.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-brain-inflammation-symptoms.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-building-slack-in-the-nervous-system.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-can-adderall-cause-depression.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-can-allergies-cause-ear-infections.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-can-anxiety-cause-constipation.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-can-constipation-cause-a-fever.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-can-infants-have-seasonal-allergies.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-can-you-outgrow-epileps.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-care-plans.jpg": {
    "w": 1200,
    "h": 912,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-cell-danger-response.jpg": {
    "w": 1200,
    "h": 900,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-chest-cold.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-children-vagus-nerve-disorders.jpg": {
    "w": 1200,
    "h": 976,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-childrens-parasympathetic-nervous-system.jpg": {
    "w": 1200,
    "h": 800,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-chiropractic-adjustment.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-chiropractic-care-cyclic-vomiting-syndrome.jpg": {
    "w": 1200,
    "h": 771,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-chiropractic-care-for-colic.jpg": {
    "w": 1200,
    "h": 706,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-chiropractic-care-for-our-child-was-unsuccessful.jpg": {
    "w": 1200,
    "h": 828,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-chronic-constipation-child.jpg": {
    "w": 1200,
    "h": 901,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-chronic-constipation.jpg": {
    "w": 1200,
    "h": 916,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-chronic-cough.jpg": {
    "w": 1200,
    "h": 831,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-chronic-ear-infections.jpg": {
    "w": 1200,
    "h": 838,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-co-regulation.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-colic-baby-symptoms.jpg": {
    "w": 1200,
    "h": 1008,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-colic-insights-and-solutions-for-exhausted-parents.jpg": {
    "w": 1200,
    "h": 818,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-colicky-baby.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-constipation.jpg": {
    "w": 1200,
    "h": 788,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-consult-with-a-px-doc.jpg": {
    "w": 1200,
    "h": 800,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-conventional-medical-functional-medicine-neurologically-focused-chiropractic-care.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-cortisol-addiction.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-cyclic-vomiting-syndrome.jpg": {
    "w": 1200,
    "h": 600,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-detox-during-neurological-healing.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-developmental-coordination-disorder.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-developmental-domains.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-developmental-milestones.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-do-antibiotics-cause-constipation.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-does-dysautonomia-go-away.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-does-your-child-have-a-busy-brain.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-dopamine-addiction.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-dorsal-vagal-shutdown.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-down-syndrome-and-chiropractic-care.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-dysautonomia-and-chiropractic-care.jpg": {
    "w": 1200,
    "h": 546,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-dysautonomia-pots.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-dyspraxia-in-adults.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-dyspraxia.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-dysregulated-nervous-system.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-ear-infections-antibiotics-and-asthma-yet-another-perfect-storm.jpg": {
    "w": 1200,
    "h": 952,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-earliest-signs-of-autism.jpg": {
    "w": 1200,
    "h": 792,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-early-signs-of-autism-in-babies.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-early-signs-of-autism.jpg": {
    "w": 1200,
    "h": 866,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-emotional-development-in-early-childhood.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-emotional-development.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-emotional-dysregulation.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-empowering-parents-perfect-storm.jpg": {
    "w": 1200,
    "h": 800,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-environmental-allergies.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-epigenetics.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-examples-of-sensory-issues.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-experience-miracles-with-chiropractic.jpg": {
    "w": 1200,
    "h": 1372,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-extreme-attention-seeking-behavior-in-children.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-failure-to-thrive.jpg": {
    "w": 1200,
    "h": 880,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-fine-motor-activities.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-flipped-baby.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-food-intolerance.jpg": {
    "w": 1200,
    "h": 900,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-gastroparesis.jpg": {
    "w": 1200,
    "h": 888,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-getting-adjusted-can-change-everything.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-gravitational-insecurity.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-green-noise-for-sleep.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-gross-motor-skills.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-growing-healthy-babies.jpg": {
    "w": 1200,
    "h": 900,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-growing-pains.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-harnessing-the-power-of-the-vagus-nerve-for-kids.jpg": {
    "w": 1200,
    "h": 978,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-healing-interventions-overload.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-healing-the-nervous-system.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-helping-kids-with-anxiety.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-heres-why-youre-not-healing.jpg": {
    "w": 1200,
    "h": 848,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-hidden-dad-pressure-strategies-to-overcome-pressure-and-burnout.jpg": {
    "w": 1200,
    "h": 700,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-high-functioning-anxiety.jpg": {
    "w": 1200,
    "h": 800,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-how-adjustments-help-you-sleep.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-how-babies-get-colic-what-you-can-do-about-it.jpg": {
    "w": 1200,
    "h": 1197,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-how-can-chiropractic-care-help.jpg": {
    "w": 1200,
    "h": 1072,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-how-chiropractic-care-can-support-parents.jpg": {
    "w": 1200,
    "h": 1600,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-how-do-babies-get-colic.jpg": {
    "w": 1200,
    "h": 773,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-how-do-i-know-if-my-child-struggles-with-sensory-processing-disorder.jpg": {
    "w": 1200,
    "h": 813,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-how-environmental-toxins-impact-childrens-health.jpg": {
    "w": 1200,
    "h": 781,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-how-long-do-antibiotics-stay-in-your-system.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-how-long-does-a-covid-headache-last.jpg": {
    "w": 1200,
    "h": 900,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-how-to-activate-parasympathetic-nervous-system.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-how-to-calm-an-overactive-nervous-system.jpg": {
    "w": 1200,
    "h": 928,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-how-to-fix-dysregulated-nervous-system.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-how-to-get-rid-of-colic.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-how-to-overcome-constant-meltdowns-tantrums-and-behavioral-outbursts.jpg": {
    "w": 1200,
    "h": 1034,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-how-to-prevent-colic.jpg": {
    "w": 1200,
    "h": 952,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-how-to-prevent-epilepsy.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-how-to-put-a-baby-to-sleep-in-40-seconds.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-how-to-stimulate-the-vagus-nerve.jpg": {
    "w": 1200,
    "h": 800,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-hpa-axis-dysfunction.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-hrv-insights-understanding-stress-impact-on-babys-nervous-system-development.jpg": {
    "w": 1200,
    "h": 1077,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-hrv-technology.jpg": {
    "w": 1156,
    "h": 826,
    "v": [
      480,
      800,
      1156
    ]
  },
  "/images/library/px-hypermobility-and-adhd.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-hyposensitivity.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-if-your-kiddo-goes-100-mph-pediatric-chiropractic-can-help-them-slow-down.jpg": {
    "w": 1200,
    "h": 674,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-infantile-spasms.jpg": {
    "w": 1200,
    "h": 1018,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-insight-emg-scans.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-insight-scans.jpg": {
    "w": 1200,
    "h": 1176,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-is-ashwagandha-safe-for-kids.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-is-autism-genetic.jpg": {
    "w": 1200,
    "h": 901,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-is-pots-genetic.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-is-stress-always-a-bad-thing.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-juvenile-epilepsy.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-juvenile-idiopathic-arthritis.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-kanners-syndrome.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-leucovorin-autism-and-frat.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-levels-of-autism.jpg": {
    "w": 1200,
    "h": 762,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-lip-smacking-autism.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-low-muscle-tone-autism.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-magnesium-for-kids-sleep.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-meltdown-vs-tantrum.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-miralax-side-effects.jpg": {
    "w": 1200,
    "h": 800,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-mitochondrial-dysfunction-and-autism.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-mold-toxicity-in-children.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-motor-control.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-motor-milestones.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-motor-planning.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-motor-skills.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-motor-tics.jpg": {
    "w": 1200,
    "h": 800,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-nasal-congestion.jpg": {
    "w": 1200,
    "h": 892,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-natural-ear-infection-remedy.jpg": {
    "w": 1200,
    "h": 924,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-natural-remedies-for-adhd.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-natural-sleep-remedies-for-kids.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-nervous-system-and-immune-system-dysregulation.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-nervous-system-dysregulation.jpg": {
    "w": 1200,
    "h": 909,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-nervous-system-healing.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-nervous-system-regulation-before-birth.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-nervous-system-regulation.jpg": {
    "w": 1200,
    "h": 800,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-nervous-system-stuck-in-fight-or-flight.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-neuro-tonal-approach.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-neurological-soft-signs-of-healing.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-neurological-stability-to-support-seizure-thresholds.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-neurologically-focused-chiropractic-care.jpg": {
    "w": 1200,
    "h": 802,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-new-year-new-doctor.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-newborn-adjustment-immediately-after-birth.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-newborn-seizures.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-night-terrors-in-toddlers.jpg": {
    "w": 1200,
    "h": 882,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-nocturnal-enuresis-bedwetting.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-ocd-sensory-issues.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-overactive-nervous-system.jpg": {
    "w": 1200,
    "h": 949,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-overcoming-developmental-milestones.jpg": {
    "w": 1200,
    "h": 1008,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-overcoming-the-adhd-burnout-cycle.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-pandas-and-ocd.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-pandas-ocd.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-pandas-syndrome-rash.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-pandas-tics.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-pandemic-babies.jpg": {
    "w": 1200,
    "h": 706,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-pans-pandas.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-pda-autism.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-pediatric-epilepsy.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-peripheral-nervous-system.jpg": {
    "w": 1000,
    "h": 548,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-piagets-stages-of-development.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-picky-eaters-explained.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-plagiocephaly.jpg": {
    "w": 1200,
    "h": 1184,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-polyvagal-ladder.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-polyvagal-therapy.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-pots-disease.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-pots-syndrome.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-pregnancy-brain.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-prenatal-stress.jpg": {
    "w": 1200,
    "h": 800,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-presyncope.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-profound-autism.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-proprioception-and-adhd.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-recognizing-the-signs-of-sensory-processing-disorder.jpg": {
    "w": 1200,
    "h": 1008,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-reduce-brain-inflammation.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-regression-during-heavy-metal-detox.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-regressions-in-your-childs-neurological-journey.jpg": {
    "w": 1200,
    "h": 900,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-regressive-autism.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-rejection-sensitive-dysphoria-and-autism.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-repair-before-regulate.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-sciatica-during-pregnancy.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-seasonal-allergies.jpg": {
    "w": 1200,
    "h": 800,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-seasonal-depression.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-seizure-medication-withdrawal.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-self-regulation-strategies-for-kids.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-sensorimotor-stage.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-sensory-diet.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-sensory-integration-disorders.jpg": {
    "w": 1200,
    "h": 804,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-sensory-issue-examples.jpg": {
    "w": 1200,
    "h": 842,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-sensory-issues-examples.jpg": {
    "w": 1200,
    "h": 675,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-sensory-modulation-disorder.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-sensory-processing-disorder-symptoms.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-sensory-processing-disorder-test.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-sensory-processing-disorder.jpg": {
    "w": 1200,
    "h": 796,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-sensory-seeking-autism.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-sensory-seeking.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-signs-of-a-colic-baby.jpg": {
    "w": 1200,
    "h": 675,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-signs-of-a-weak-immune-system-in-children.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-signs-of-autism-during-pregnancy.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-signs-of-autism-in-babies.jpg": {
    "w": 1200,
    "h": 800,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-signs-your-nervous-system-is-dysregulated.jpg": {
    "w": 1200,
    "h": 827,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-signs-your-newborn-is-stressed.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-sleep-disorders-in-children.jpg": {
    "w": 1200,
    "h": 872,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-sleep-supports-children-health.jpg": {
    "w": 1200,
    "h": 944,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-smoother-transitions.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-somatic-nervous-system.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-somniphobia.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-sore-throat-remedies.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-speech-delay-in-children.jpg": {
    "w": 1200,
    "h": 792,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-speech-delay-in-toddlers.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-speech-delay.jpg": {
    "w": 1200,
    "h": 908,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-start-and-maybe-stop-supplements.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-strabismus-in-children.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-strep-throat-in-infants.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-stress-during-pregnancy.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-subluxation-in-stressed-adults.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-subluxation-region.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-subluxation-stress-illness.jpg": {
    "w": 1200,
    "h": 928,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-sympathetic-nervous-system.jpg": {
    "w": 1200,
    "h": 800,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-symptoms-of-too-much-antibiotics.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-tantrums-meltdowns-and-emotional-outbursts.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-teen-anxiety-and-depression.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-the-big-vaccine-question.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-the-first-year-of-life.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-the-hidden-impact-of-stress-on-healthy-babies.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-the-missing-link-in-youth-sports.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-the-neurological-perspective-on-constipation.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-the-perfect-storm-in-pregnancy.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-the-perfect-storm-insights-into-childhood-neurological-disorders.jpg": {
    "w": 1200,
    "h": 949,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-the-roadmap-to-neurological-healing.jpg": {
    "w": 1200,
    "h": 840,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-the-side-effects-of-pediatric-chiropractic-care.jpg": {
    "w": 1200,
    "h": 984,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-the-silent-epidemic.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-the-supplement-trap.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-the-surprising-secret-to-unlocking-your-childs-health-why-less-is-actually-more.jpg": {
    "w": 1200,
    "h": 848,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-the-top-10-reasons-to-get-a-boost-adjustment.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-the-truth-about-mthfr.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-tired-of-endless-medications-diet-changes-and-supplements-for-inflammation-there-may-be-more-going-on.jpg": {
    "w": 1200,
    "h": 987,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-toddler-sleep-regression.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-toe-walking-and-autism.jpg": {
    "w": 1200,
    "h": 969,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-tongue-tied-baby.jpg": {
    "w": 1200,
    "h": 1127,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-traumatic-birth.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-types-of-autism.jpg": {
    "w": 722,
    "h": 513,
    "v": []
  },
  "/images/library/px-understanding-and-addressing-the-root-causes-of-speech-delays-in-children.jpg": {
    "w": 1200,
    "h": 1013,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-understanding-fevers.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-understanding-sensory-issues-in-kids-a-comprehensive-approach.jpg": {
    "w": 1200,
    "h": 876,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-understanding-sensory-issues-in-kids.jpg": {
    "w": 1200,
    "h": 768,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-understanding-the-different-types-of-chiropractic-care.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-unlocking-torticollis-insight-scans-and-chiropractic-care.jpg": {
    "w": 1200,
    "h": 922,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-vagus-nerve-and-adhd.jpg": {
    "w": 1200,
    "h": 909,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-vagus-nerve-and-autism.jpg": {
    "w": 1200,
    "h": 874,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-vagus-nerve-and-autoimmune-connection.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-vagus-nerve-and-immune-system.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-vagus-nerve-and-inflammation.jpg": {
    "w": 1200,
    "h": 776,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-vagus-nerve-disorders.jpg": {
    "w": 1200,
    "h": 800,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-vagus-nerve-dysfunction.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-vagus-nerve-function.jpg": {
    "w": 1200,
    "h": 948,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-vagus-nerve-inflammation.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-vagus-nerve-stimulation-at-home.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-vagus-nerves-role.jpg": {
    "w": 1200,
    "h": 1223,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-vasovagal-syncope-seizure.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-vasovagal-syncope.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-visceral-hypersensitivity.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-vns-therapy.jpg": {
    "w": 1200,
    "h": 922,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-vocal-tics-in-children.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-w-sitting.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-what-are-the-common-antibiotics-side-effects.jpg": {
    "w": 1200,
    "h": 996,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-causes-adhd-in-children.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-what-causes-colic-in-babies.jpg": {
    "w": 1200,
    "h": 675,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-causes-colic.jpg": {
    "w": 1200,
    "h": 880,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-causes-eczema-in-children.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-what-causes-migraines-in-children.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-what-causes-scoliosis-in-kids.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-what-causes-seizures.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-what-causes-subluxation.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-what-causes-tics-in-children.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-what-is-a-colic-baby.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-is-aba-therapy.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-is-anxiety.jpg": {
    "w": 1200,
    "h": 800,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-is-autism.jpg": {
    "w": 764,
    "h": 584,
    "v": [
      480,
      764
    ]
  },
  "/images/library/px-what-is-birth-trauma.jpg": {
    "w": 1200,
    "h": 990,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-is-colic.jpg": {
    "w": 1200,
    "h": 828,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-is-dysautonomia.jpg": {
    "w": 1200,
    "h": 930,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-is-dystonia.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-is-enuresis.jpg": {
    "w": 1200,
    "h": 1036,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-is-level-1-autism.jpg": {
    "w": 1200,
    "h": 628,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-is-level-3-autism.jpg": {
    "w": 1200,
    "h": 864,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-is-neurostorming.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-what-is-overstimulation.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-what-is-pans-disease.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-what-is-pattern-analysis.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-what-is-pots-syndrome.jpg": {
    "w": 1024,
    "h": 683,
    "v": [
      480,
      800,
      1024
    ]
  },
  "/images/library/px-what-is-preeclampsia.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-what-is-proprioception.jpg": {
    "w": 1200,
    "h": 800,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-is-rsv.jpg": {
    "w": 1200,
    "h": 933,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-is-sensory-overload.jpg": {
    "w": 1200,
    "h": 919,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-is-sensory-processing-disorder.jpg": {
    "w": 1200,
    "h": 927,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-is-silent-reflux.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-what-is-subluxation.jpg": {
    "w": 1200,
    "h": 772,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-is-the-hpa-axis.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-what-is-the-vagus-nerve.jpg": {
    "w": 1200,
    "h": 829,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-is-torticollis.jpg": {
    "w": 1200,
    "h": 865,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-what-sleep-does-for-a-childs-brain.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-where-does-autism-come-from.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-why-do-i-get-overstimulated-so-easily.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-why-does-my-baby-only-sleep-when-held.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-why-does-my-child-get-fixated-on-things.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-why-is-my-baby-so-fussy.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-why-medication-fails.jpg": {
    "w": 1200,
    "h": 794,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-why-too-many-treatments-can-hinder-your-childs-healing.jpg": {
    "w": 1200,
    "h": 1149,
    "v": [
      480,
      800,
      1200
    ]
  },
  "/images/library/px-why-we-scan.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-why-wont-my-baby-latch.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-why-you-should-get-adjusted-postpartum.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/px-worn-out-adults.jpg": {
    "w": 1000,
    "h": 600,
    "v": [
      480,
      800,
      1000
    ]
  },
  "/images/library/seasonal-a-nervous-system-friendly-way-to-start-the-new-year.jpg": {
    "w": 960,
    "h": 640,
    "v": [
      480,
      800,
      960
    ]
  },
  "/images/library/seasonal-building-a-wellness-plan-for-the-decades-ahead.jpg": {
    "w": 1024,
    "h": 683,
    "v": [
      480,
      800,
      1024
    ]
  },
  "/images/library/seasonal-consistency-beats-intensity-for-a-changing-nervous-system.jpg": {
    "w": 960,
    "h": 640,
    "v": [
      480,
      800,
      960
    ]
  },
  "/images/library/seasonal-gardening-without-flaring-up-your-joints.jpg": {
    "w": 683,
    "h": 1024,
    "v": [
      480,
      683
    ]
  },
  "/images/library/seasonal-getting-your-childs-spine-ready-for-back-to-school.jpg": {
    "w": 960,
    "h": 640,
    "v": [
      480,
      800,
      960
    ]
  },
  "/images/library/seasonal-health-goals-your-whole-family-can-actually-keep.jpg": {
    "w": 1024,
    "h": 1010,
    "v": [
      480,
      800,
      1024
    ]
  },
  "/images/library/seasonal-how-to-rake-leaves-without-wrecking-your-back.jpg": {
    "w": 1024,
    "h": 684,
    "v": [
      480,
      800,
      1024
    ]
  },
  "/images/library/seasonal-keeping-your-familys-nervous-system-steady-through-holiday-travel.jpg": {
    "w": 1024,
    "h": 683,
    "v": [
      480,
      800,
      1024
    ]
  },
  "/images/library/seasonal-protecting-your-spine-on-a-long-road-trip.jpg": {
    "w": 1024,
    "h": 769,
    "v": [
      480,
      800,
      1024
    ]
  },
  "/images/library/seasonal-staying-mobile-is-how-you-protect-your-bones-as-you-age.jpg": {
    "w": 960,
    "h": 640,
    "v": [
      480,
      800,
      960
    ]
  },
  "/images/library/seasonal-surviving-cookout-season-without-a-sore-back.jpg": {
    "w": 960,
    "h": 641,
    "v": [
      480,
      800,
      960
    ]
  },
  "/images/library/seasonal-what-your-childs-bathroom-habits-are-actually-telling-you.jpg": {
    "w": 960,
    "h": 608,
    "v": [
      480,
      800,
      960
    ]
  },
  "/images/library/seasonal-why-a-run-down-nervous-system-catches-every-fall-bug.jpg": {
    "w": 960,
    "h": 640,
    "v": [
      480,
      800,
      960
    ]
  },
  "/images/library/seasonal-why-fall-yard-cleanup-triggers-sciatica-flares.jpg": {
    "w": 1024,
    "h": 768,
    "v": [
      480,
      800,
      1024
    ]
  },
  "/images/library/seasonal-your-kid-fell-again-what-actually-warrants-a-closer-look.jpg": {
    "w": 1024,
    "h": 683,
    "v": [
      480,
      800,
      1024
    ]
  },
  "/images/reception.jpg": {
    "w": 425,
    "h": 425,
    "v": [
      425
    ]
  },
  "/images/saylor-child-neck.jpg": {
    "w": 425,
    "h": 425,
    "v": []
  },
  "/images/saylor-report.jpg": {
    "w": 425,
    "h": 425,
    "v": []
  },
  "/images/saylor-skull-education.jpg": {
    "w": 425,
    "h": 425,
    "v": []
  },
  "/images/saylor-upper-back.jpg": {
    "w": 425,
    "h": 425,
    "v": [
      425
    ]
  },
  "/images/site-2026/saylor-rachel-three-generations-w918.webp": {
    "w": 918,
    "h": 1280,
    "v": [
      480,
      800,
      918
    ]
  }
}
